import { ArticleFields } from '@pressreader/content-types';
import { error } from '@pressreader/logger';
import { httpGet } from '@pressreader/services';
import { toCamelCase } from '@pressreader/utils';

import { IArticleDto } from '../types/article';

interface GetArticleRequest {
    articleId: string;
    fields: ArticleFields;

    lang?: string;
    injected?: boolean;
    confirm?: boolean;
    isHyphenated?: boolean;

    fullBody?: boolean;
}

export async function getArticle(request: GetArticleRequest) {
    const data: {
        articleFields: ArticleFields;
        lang?: string;
        injected?: boolean;
        confirm?: boolean;
        isHyphenated?: boolean;
        fullBody?: boolean;
    } = { articleFields: request.fields };

    if (request.lang) {
        data.lang = request.lang;
    }

    if (request.injected) {
        data.injected = request.injected;
    }

    if (request.confirm) {
        data.confirm = request.confirm;
    }

    data.isHyphenated = request.isHyphenated === undefined ? true : request.isHyphenated;
    data.fullBody = request.fullBody ?? true;

    try {
        const dto = await httpGet<IArticleDto>(`v1/articles/${request.articleId}`, '', data);
        return toCamelCase(dto);
    } catch (e) {
        error(`Get article failed. ArticleId: ${request.articleId}`, e);
        throw e;
    }
}

export function getArticleDirectLink(articleId: string | number) {
    return httpGet<{ url: string }>('v1/articles', `${articleId}/directlink`);
}
